module.exports = __webpack_public_path__ + "img/img_landing_news.a1a9d058.jpg";